import styled, { css } from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { media } from 'components/styles';

const INPUT_MODIFIERS = {
	primary: ({ theme }) => css`
		border: 1px solid ${theme.personalData.form.input.borderColor};
		border-radius: 4px;
		font-size: 1.4rem;
		background: ${theme.personalData.form.input.backgroundColor};

		&:disabled {
			opacity: 0.5;
		}

		&::placeholder {
			color: ${theme.personalData.form.input.placeholderColor};
		}
	`
};

const baseStyle = css`
	width: 100%;
	height: 4rem;
	padding: 10px 12px;
	background-color: transparent;
	border: 1px solid ${({ theme }) => theme.line};
	border-radius: 4px;
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
	transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
	font-size: 14px;
	line-height: 1.28;
	color: ${({ theme }) => theme.grayMedium};

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.blueLight};
		box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
			0 0 8px rgba(102, 175, 233, 0.6);
	}

	::-webkit-input-placeholder {
		color: ${({ theme }) => theme.silver};
	}

	&.errors {
		border: 1px solid ${({ theme }) => theme.red};
	}

	&[type='number'] {
		appearance: textfield;
		-moz-appearance: textfield;
	}

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	${applyStyleModifiers(INPUT_MODIFIERS)};
`;

const Input = styled.input`
	${baseStyle}
`;

const Select = styled.select`
	${baseStyle}
`;

const Area = styled.textarea`
	${baseStyle}
	height: 14rem;
	${media.min.medium(css`
		height: 24.4rem;
	`)}
	resize: none;
`;

export { Input, Select, Area };
